import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect } from 'react';
import globalEvents from '@/utils/globalEvents';
// Hook to prompt user confirmation
// requiring ConfirmationPrompt component
// to be mounted in the app
export default function useConfirmation(_ref) {
  let {
    id,
    title,
    onCancel,
    onConfirm
  } = _ref;
  const openConfirmationPrompt = useCallback(() => {
    globalEvents.trigger('confirmationPromptOpen', {
      detail: _objectSpread({
        id
      }, title ? {
        title
      } : {})
    });
  }, [id, title]); // Listen for user's choice
  // and call the appropriate callback

  useEffect(() => {
    return globalEvents.subscribe('confirmationPromptClose', evt => {
      var _evt$detail, _evt$detail2;

      // Make sure the event is bound to the correct
      // confirmation prompt
      if ((evt === null || evt === void 0 ? void 0 : (_evt$detail = evt.detail) === null || _evt$detail === void 0 ? void 0 : _evt$detail.id) !== id) return; // Call the appropriate callback
      // based on user's choice

      const confirmed = Boolean(evt === null || evt === void 0 ? void 0 : (_evt$detail2 = evt.detail) === null || _evt$detail2 === void 0 ? void 0 : _evt$detail2.confirm);
      const fn = confirmed ? onConfirm : onCancel;
      typeof fn === 'function' && fn();
    });
  }, [onConfirm, onCancel, id]);
  return {
    openConfirmationPrompt
  };
}